import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskJourneysRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-journeys',
	path: '/jira/servicedesk/projects/:projectKey/settings/journeys',
	exact: true,
};
